import { truncate } from 'lodash';
import Draggable from 'react-draggable';

import { clsxm } from '@app/styles/clsxm';

import {
  Dialog as MuiDialog,
  DialogProps,
  DialogTitle,
  Typography,
  Paper,
  PaperProps,
  useMediaQuery,
  useTheme,
} from '@mui/material';

function PaperComponent(props: PaperProps) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"], .not-draggable'}>
      <Paper {...props} />
    </Draggable>
  );
}

type Props = {
  headerTitle?: string;
  headerSubtitle?: string;
  headerEntity?: string;
  paperClassName?: string;
  hideHeader?: boolean;
  headerContent?: React.ReactNode;
} & DialogProps;

export const Dialog: React.FC<Props> = ({
  children,
  open,
  headerTitle,
  headerEntity,
  onClose,
  paperClassName,
  hideHeader = true,
  headerContent,
  headerSubtitle,
  ...props
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <MuiDialog
      open={open}
      PaperProps={{
        className: clsxm('rounded-lg px-14 py-16 max-w-[500px]', paperClassName),
      }}
      onClose={onClose}
      {...props}
      {...(!isMobile
        ? {
            PaperComponent: PaperComponent,
            'aria-labelledby': 'draggable-dialog-title',
          }
        : {})}
      disablePortal
    >
      {!hideHeader && (
        <DialogTitle id="draggable-dialog-title" className="cursor-move">
          <div>
            <Typography noWrap>{truncate(headerTitle, { length: 120 })}</Typography>
            {!!headerSubtitle && <Typography noWrap>{truncate(headerSubtitle, { length: 120 })}</Typography>}
          </div>

          {headerEntity && <Typography>{headerEntity}</Typography>}
          {headerContent}
        </DialogTitle>
      )}

      {children}
    </MuiDialog>
  );
};
